(function () {
  'use strict';

  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = arr[i];
      arr[i] = arr[j];
      arr[j] = temp;
    }
    return arr;
  }

  function run() {
    /*
      Try every possible selector Prestige might use.
      The first one that exists and has children wins.
    */
    var selectors = [
      '#product-grid',
      '.product-grid',
      '.collection-product-grid',
      '.product-list',
      '[data-product-grid]',
      '.products-grid',
      '.collection__products',
      '.product-grid-container',
      'ul.product-list',
      '.product-grid__inner'
    ];

    var grid = null;

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.children.length > 1) {
        grid = el;
        break;
      }
    }

    if (!grid) {
      /* Last resort — log what grids exist so we can debug */
      console.log('[Shuffle] Could not find product grid. Page classes:',
        document.body.className);
      return;
    }

    console.log('[Shuffle] Found grid:', grid.className || grid.id, '— cards:', grid.children.length);

    var cards = Array.from(grid.children);
    shuffle(cards);
    cards.forEach(function (card) {
      grid.appendChild(card);
    });

    console.log('[Shuffle] Done — products shuffled');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

})();